<svelte:options accessors/>

{#if showCards}
  <CreditCardList config={config} on:registerCard={() => showCards = false}/>
{:else}
  <CreditCardForm config={config} on:cancel={() => showCards = true}/>
{/if}

<script>
  export let config;

  import CreditCardForm from './credit-card-form.svelte';
  import CreditCardList from './credit-card-list.svelte';
  import { checkoutMode } from './stores.js'

  let showCards = config.credit_cards.length > 0;
  $: $checkoutMode = showCards ? 'list' : 'form';
</script>
